import Step18 from './Step18-compose';

export default Step18;
